module.exports = __webpack_public_path__ + "img/ancientruins.1c172655.jpg";